import React, { useRef } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl, OverlayTrigger, Popover } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Spinner from '../../../../../components/Loaders/Spinner';
import Alert from '../../../../../components/Alert';
import { convertStringToHtml, ticketToolbar } from '../../../helpers';
import TipTap from '../../../../../components/TipTap';

const AddEditForm = ({ open, toggle, modalData, onSubmit, onConfirmDelete, values, onChange, isFetching, errorText }) => {
  let ref = useRef(null);
  const inputRef = useRef(null);

  const onChangeForm = (e) => {
    e.persist();
    onChange
      && onChange((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
  };

  const onChangeContent = (content) => {
    onChange((prev) => ({
      ...prev,
      body: content,
    }));
  }

  const onDelete = () => {
    ref?.handleHide();
    onConfirmDelete();
  };

  const popover = (
    <Popover id="popover-trigger-click-root-close" title="" className="text-center">
      <Button bsStyle="primary" bsSize="sm" onClick={onDelete}>Delete</Button>
      <Button bsSize="sm" className="ml-8" onClick={() => ref?.handleHide()}>Cancel</Button>
    </Popover>
  );

  return (
    <Modal show={open} onHide={toggle} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{modalData.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorText && <Alert text={errorText} />}
        <form onSubmit={onSubmit}>
          <FormGroup>
            <ControlLabel>Title</ControlLabel>
            <FormControl type="text" name="title" value={values.title} onChange={onChangeForm} />
          </FormGroup>
          <FormGroup className="ticket-editor">
            <ControlLabel>Text</ControlLabel>
            <TipTap
              toolbar={ticketToolbar}
              content={convertStringToHtml(values.body)}
              ref={inputRef}
              onChange={onChangeContent}
            />
          </FormGroup>
        </form>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button bsStyle="primary" onClick={onSubmit} disabled={isFetching}>
          {isFetching && <Spinner />}
          <span>{modalData.okBtnText}</span>
        </Button>
        <Button onClick={toggle}>Cancel</Button>
        {modalData.type === 'edit' && (
          <div className="pull-right">
            <OverlayTrigger ref={(r) => (ref = r)} trigger="click" rootClose placement="top" overlay={popover}>
              <Button bsStyle="link">Delete</Button>
            </OverlayTrigger>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

AddEditForm.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
  modalData: PropTypes.object,
  onConfirmDelete: PropTypes.func,
  onSubmit: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func,
  isFetching: PropTypes.bool,
  errorText: PropTypes.string,
};

export default AddEditForm;
